export default __webpack_public_path__ + "files/media/md-membership.4065f816.jpg";